<template>
  <transition>
    <div class="notice flexcenter">
      <div class="notice-dialog flexcenter">
        <div class="modal-close" @click="$emit('close')"></div>
        <div class="lbold font16">
          <p>音声が認識できない場合、以下を確認してください。</p>
          <p>1.設定で音声認識が有効になっているか確認してください。無効の場合は有効にしてください。</p>
          <p>2.音声認識が有効にできない場合、最新版にアップデートしてください。</p>
        </div>
        <div class="flexcenter buttons">
          <button v-if="canShowUpdatePage()" class="button" type="button" @click="showUpdatePage()">アップデートページへ</button>
          <button v-else class="button" type="button" @click="$emit('close')">OK</button>
        </div><!-- flexcenter buttons -->
      </div><!-- notice-dialog flexcenter -->
    </div><!-- notice flexcenter -->
  </transition>
</template>

<script>
import common from "@/mixin/common";

const URL_BIND_STRING_APNAME = "{APNAME}";

/**
 * アップデートページ表示対象バージョン
 */
// Basic版au
const TARGET_VERSION_AU = 9;
// Basic版softbank
const TARGET_VERSION_SOFTBANK = 9;

/**
 * アップデートページURL
 */
// Basic版au
const URL_AU = "http://pass.auone.jp/app/detail?app_id=8662210000032";
// Basic版softbank
const URL_SOFTBANK = "http://links.mobileplatform.solutions/softbank/app?id=com.mobiroo.n.sourcenextcorporation." + URL_BIND_STRING_APNAME;

export default {
  name: "notice",
  mixins: [
    common,
  ],
  methods: {
    /**
     * アップデートページ表示可否
     *
     * @return {Boolean} true：アップデートページを表示する, false：アップデートページを表示しない
     */
    canShowUpdatePage: function() {
      this.log("Notice start canShowUpdatePage");

      var target = this.isAu() ? TARGET_VERSION_AU : TARGET_VERSION_SOFTBANK;
      this.log("Notice canShowUpdatePage from version " + target + " to target");

      var current = typeof window.Phone.GetVersionCode == "function" ? Number(window.Phone.GetVersionCode()) : NaN;
      this.log("Notice canShowUpdatePage current version:" + current);

      var result = target <= current;
      this.log("Notice canShowUpdatePage result:" + result);
      return result;
    },
    /**
     * アップデートページ表示
     */
    showUpdatePage: function () {
      this.log("Notice start showUpdatePage");

      var url;
      if (this.isAu()) {
        // Basic版au
        url = URL_AU;
      } else {
        // Basic版softbank
        url = URL_SOFTBANK.replace(URL_BIND_STRING_APNAME, this.getApName());
      }
      this.log("Notice showUpdatePage url:" + url);

      // 表示
      window.Phone.StartBrowser(url);
    }
  },
  created: function () {
    this.log("Notice start created");
  },
  mounted: function () {
    this.log("Notice start mounted");
    this.setBodyStylePosition(true);
  },
  beforeDestroy: function () {
    this.log("Notice start beforeDestroy");
    this.setBodyStylePosition(false);
  }
};
</script>

<style lang="scss">
@import "src/assets/style/modal";
</style>



// WEBPACK FOOTER //
// Notice.vue?76435858